declare const $crisp: any;

export const openChat = () => {
  if (typeof $crisp !== 'undefined') {
    $crisp.push(['do', 'chat:show']);
    $crisp.push(['do', 'chat:open']);
    $crisp.push(["on", "chat:closed",
      () => {
        $crisp.push(['do', 'chat:close']);
        $crisp.push(['do', 'chat:hide']);
      }
    ]);
  }
};

export const openEmail = ()=> {
  const email = 'support' + '@' + 'selfcv.com';

  window.location.href = `mailto:${email}`;
};

